import React from 'react';
import { cn } from '../../../Utils/cn';

const CheckoutError = ({ errors, className }) => {
  if (!errors?.length) {
    return null;
  }

  return (
    <>
      {errors?.length > 1 ? (
        <ul className={cn(className || 'body')}>
          {errors?.map((error, index) => (
            <li key={index}>{error}</li>
          ))}
        </ul>
      ) : (
        <p className={cn(className || 'body')}>{errors?.[0]}</p>
      )}
    </>
  );
};

export default CheckoutError;
